import { render, staticRenderFns } from "./Privacy Policy.vue?vue&type=template&id=b9ec3c2c&"
import script from "./Privacy Policy.vue?vue&type=script&lang=js&"
export * from "./Privacy Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports